import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { PdpStore } from '@ff-os/pdp-shared-redux/store';
import { i18n } from 'i18next';
import { hasPreview, PreviewSlot } from '../plugin-loaders/PreviewSlot';

export const PreviewUi = ({ store, i18n }: Props) => (
    <React.StrictMode>
        <Provider store={store}>
            <I18nextProvider i18n={i18n}>
                {hasPreview(store) && (
                    <div className='idt-slot'>
                        <PreviewSlot />
                    </div>
                )}
            </I18nextProvider>
        </Provider>
    </React.StrictMode>
);

type Props = {
    store: PdpStore;
    i18n: i18n;
};